// extracted by mini-css-extract-plugin
export default {"container":"Contacts_container__hokI2","title":"Contacts_title__3h-J6","subtitle":"Contacts_subtitle__sidYm","empty":"Contacts_empty__pVQV-"};